import { useState } from 'react';
import { Users, DollarSign, Receipt, Star } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

// Import existing page components as sections
import StaffApplicants from './StaffApplicants';
import StaffEarnings from './StaffEarnings';
import Invoices from './Invoices';
import InfluencerCommissions from './InfluencerCommissions';

export default function StaffHub() {
  const [activeTab, setActiveTab] = useState('applicants');

  return (
    <div className="space-y-4 sm:space-y-6">
      <div>
        <h1 className="text-2xl sm:text-4xl font-bold font-heading tracking-tight" data-testid="staff-hub-title">
          Staff & Finance Hub
        </h1>
        <p className="text-muted-foreground text-sm mt-1">Manage staff, earnings, invoices, and influencer commissions</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="w-full grid grid-cols-4 h-auto">
          <TabsTrigger value="applicants" className="flex flex-col sm:flex-row items-center gap-1 py-2 text-xs sm:text-sm">
            <Users className="h-4 w-4" />
            <span className="hidden sm:inline">Staff</span> Applicants
          </TabsTrigger>
          <TabsTrigger value="earnings" className="flex flex-col sm:flex-row items-center gap-1 py-2 text-xs sm:text-sm">
            <DollarSign className="h-4 w-4" />
            <span className="hidden sm:inline">Staff</span> Earnings
          </TabsTrigger>
          <TabsTrigger value="invoices" className="flex flex-col sm:flex-row items-center gap-1 py-2 text-xs sm:text-sm">
            <Receipt className="h-4 w-4" />
            Invoices
          </TabsTrigger>
          <TabsTrigger value="influencers" className="flex flex-col sm:flex-row items-center gap-1 py-2 text-xs sm:text-sm">
            <Star className="h-4 w-4" />
            Influencers
          </TabsTrigger>
        </TabsList>

        <TabsContent value="applicants" className="mt-6">
          <StaffApplicantsContent />
        </TabsContent>

        <TabsContent value="earnings" className="mt-6">
          <StaffEarningsContent />
        </TabsContent>

        <TabsContent value="invoices" className="mt-6">
          <InvoicesContent />
        </TabsContent>

        <TabsContent value="influencers" className="mt-6">
          <InfluencerCommissionsContent />
        </TabsContent>
      </Tabs>
    </div>
  );
}

// Wrapper components that render without the header (since we have our own)
function StaffApplicantsContent() {
  return <StaffApplicants embedded={true} />;
}

function StaffEarningsContent() {
  return <StaffEarnings embedded={true} />;
}

function InvoicesContent() {
  return <Invoices embedded={true} />;
}

function InfluencerCommissionsContent() {
  return <InfluencerCommissions embedded={true} />;
}
